import { z } from 'zod';

export const UserSchema = z.object({
  userId: z.number().nullable(),
  subscriptionState: z.string(),
  role: z.string(),
  subscriptionType: z.string(),
  planCode: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  shippingCountry: z.string(),
  email: z.string(),
  uuid: z.string().optional(),
});

export const UserInfoSchema = z.object({
  lives: z.array(
    z.object({
      id: z.string(),
      live: z.boolean(),
      status: z.string(),
    }),
  ),
  user: UserSchema,
  avatar: z.string(),
  seasonCode: z.string(),
  errors: z.record(z.string()).optional(),
  loggedIn: z.boolean(),
});

export const UserTraitsSchema = z.object({
  role: z.string().optional(),
  memberStatus: z.string().optional(),
  planCode: z.string().optional(),
  experimentName: z.string().optional(),
  variationName: z.string().optional(),
  featureFlagName: z.string().optional(),
  campaignId: z.union([z.number(), z.string()]).optional(),
  fffUUID: z.string().optional(),
  name: z.string().optional(),
  email: z.string().optional(),
  account_code: z.string().optional(),
  phoneNumber: z.string().optional(),
  fff_session_id: z.string().optional(),
});

export type User = z.infer<typeof UserSchema>;
export type UserInfo = z.infer<typeof UserInfoSchema>;
export type UserTraits = z.infer<typeof UserTraitsSchema>;
